import getMaintenanceWindowVariables from './maintenance';
import getTealiumVariables from './tealium';
import getAppDynamicsVariables from './appDynamics';
import getSessionVariables from './session';

export default () => {
  if (!global.BANKING_DASHBOARD_URL) {
    throw new Error('BANKING_DASHBOARD_URL environment variable is not specified');
  }

  return {
    bankingDashboardUrl: global.BANKING_DASHBOARD_URL,
    forceLocale: global.FORCE_LOCALE,
    maintenanceWindow: {
      ...getMaintenanceWindowVariables(),
    },
    tealium: {
      ...getTealiumVariables(),
    },
    appDynamics: {
      ...getAppDynamicsVariables(),
    },
    session: {
      ...getSessionVariables(),
    },
  };
};
